import { combineReducers, createStore, compose, applyMiddleware, Middleware } from 'redux'
import { routeReducer, syncHistory } from 'react-router-redux'
// import { browserHistory } from "react-router";
import thunk from 'redux-thunk'
import {forms, FormState, common, CommonState} from '../reducers'
import { createLogger } from 'redux-logger'
import {Store} from "react-redux";
import createHistory from 'history/lib/createBrowserHistory';
import { connectRouter } from "connected-react-router";

export type RootState = {
    router: any,
    forms: FormState,
    common: CommonState
}

export const history = createHistory({
    basename: '/residents'
})

const logger = createLogger() as Middleware;
// export const history = browserHistory;
// const reduxRouterMiddleware = history;

const rootReducer = combineReducers<RootState>({
    router: connectRouter(history),
    forms: forms,
    common: common,
});

let store : Store<RootState>;

if(process.env.NODE_ENV === 'production') {
    store = createStore(rootReducer, compose(applyMiddleware(thunk)));
} else {
    store = createStore(rootReducer, compose(applyMiddleware(thunk))); //, logger
}

export { store };
